import { render } from "./ActionDropdown.vue?vue&type=template&id=81f7ff18&scoped=true"
const script = {}

import "./ActionDropdown.vue?vue&type=style&index=0&id=81f7ff18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f7ff18"]])

export default __exports__